import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { Card } from 'react-bootstrap';

const ComplementoINEResumen = ({ data = {}, onEdit, onDelete }) => {

  const handleOnDelete = () => {
    onDelete('INE');
  }

  const handleOnEdit = () => {
    onEdit('INE', data);
  }

  return (
    <Card>
      <Card.Body>
        <Card.Subtitle className="text-center">INE, Versión { data.Version }</Card.Subtitle>

        <Row>
          <Col>
            <Button variant="danger"
              className="mr-3"
              onClick={ handleOnDelete }
            >
              Quitar
            </Button>

            <Button variant="secondary"
              onClick={ handleOnEdit }
            >
              Editar
            </Button>
          </Col>
        </Row>

      </Card.Body>
    </Card>
  )
}

export default ComplementoINEResumen;
